export const FRIENZZI_BOT_UID = 'frienzzi-bot';
export const FRIENZZI_BOT_NAME = 'Frienzzi Bot';
export const FRIENZZI_BOT_USERNAME = 'frienzzi';
